<template>
    <q-dialog
        v-model="showDialog"
        maximized
        transition-show="slide-up"
        transition-hide="slide-down"
    >
        <q-card>
            <q-bar class="bg-primary text-white">
                <span>{{$t('transfers.cm_withdrawals')}}</span>
                <q-space />
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip content-class="bg-white text-primary">Close</q-tooltip>
                </q-btn>
            </q-bar>

            <q-card-section class="q-pa-md">
                <crown-money-withdrawal-table />
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
<script>

import CrownMoneyWithdrawalTable from "./CrownMoneyWithdrawalTable"
export default {
    name: "CrownMoneyWithdrawalsDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        showDialog: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    created() {},
    mounted() {},
    watch: {},
    components: {
        CrownMoneyWithdrawalTable
    },
}
</script>
<style>

</style>
